<nav role="tablist" [class]="listClasses()" [attr.aria-label]="ariaLabel()">
  @for (item of items(); track item.key) {
    <button
      type="button"
      role="tab"
      [class]="tabClasses(item)"
      [style.line-height]="lineHeight()"
      [disabled]="item.disabled"
      [attr.aria-selected]="isActive(item)"
      [svcTestId]="testIdPrefix() + '__tab--' + item.key"
      (click)="onSelect(item)"
    >
      {{ item.label }}
    </button>
  }
</nav>
